<template>
  <v-card>
    <v-card-text>
      <button v-if="model.status=='paid'" @click.stop="confirm()">Confirmer la commande</button>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  props: {
    order: {
      type: Object,
      require: true
    }
  },
  methods: {
    confirm() {
      this.$store.dispatch("order/confirm", this.order.id).then(() => {
        this.$emit("update");
      });
    }
  }
};
</script>

<style>
</style>